<div class="add-problem-modal">
  <div class="modal-header">
    <button
      aria-label="Close"
      class="close"
      data-dismiss="modal"
      type="button"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true"> × </span>
    </button>
  </div>
  <div class="modal-body">
    <img
      [src]="src"
      (load)="hideLoader()"
      (error)="hideLoader()"
      alt="Prescription Image"
    />
    <ngx-spinner
      name="imageSpinner"
      bdColor=""
      size="medium"
      color="#000000"
      type="ball-8bits"
      [fullScreen]="false"
    ></ngx-spinner>
  </div>
  <div class="modal-footer">
    <button class="btn close-btn" (click)="bsModalRef.hide()">Close</button>
  </div>
</div>
